import React, { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const LanguageSwitcher = ({ transparent }) => {
  const { lang, setLang, languages } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="language-switcher"
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-1.5 text-sm transition-colors ${
          transparent ? "text-white/90 hover:text-white" : "text-petrol/80 hover:text-petrol"
        }`}
      >
        <Globe size={16} strokeWidth={1.5} />
        <span className="overline text-[11px]">{lang.toUpperCase()}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-3 w-40 bg-[#FDFBF7] border border-line rounded-sm shadow-xl py-1 z-50">
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className="w-full flex items-center justify-between px-4 py-2 text-sm text-petrol hover:bg-beige transition-colors"
            >
              {l.name}
              {lang === l.code && <Check size={14} className="text-gold" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
